import { render, staticRenderFns } from "./RatingItem.vue?vue&type=template&id=6c9dde9a&"
import script from "./RatingItem.vue?vue&type=script&lang=js&"
export * from "./RatingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports